import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaSpinner, FaCheckCircle, FaExclamationTriangle, FaFolder } from 'react-icons/fa';
import '../../styles/Auth.css';

const OAuthCallback = () => {
  const [status, setStatus] = useState('processing');
  const [message, setMessage] = useState('Processing your authentication...');
  const navigate = useNavigate();
  const location = useLocation();
  
  useEffect(() => {
    // Parse query parameters
    const searchParams = new URLSearchParams(location.search);
    const success = searchParams.get('success');
    const error = searchParams.get('error');
    
    if (success === 'true') {
      setStatus('success');
      setMessage('Successfully connected to MyMiniFactory!');
      // Redirect to dashboard after a short delay
      setTimeout(() => {
        navigate('/dashboard');
      }, 2000);
    } else {
      setStatus('error');
      setMessage(`Connection failed: ${error || 'Unknown error'}`);
      // Redirect to home after a longer delay
      setTimeout(() => {
        navigate('/auth/mmf-connect');
      }, 3000);
    }
  }, [location, navigate]);
  
  return (
    <div className="oauth-callback-container">
      <div className="auth-card">
        <div className="auth-logo">
          <FaFolder className="auth-logo-icon" />
        </div>
        
        <h2>MyMiniFactory Connection</h2>
        
        <div className={`status-icon ${status}`}>
          {status === 'processing' && <FaSpinner className="fa-spin" />}
          {status === 'success' && <FaCheckCircle />}
          {status === 'error' && <FaExclamationTriangle />}
        </div>
        
        <p className="status-message">{message}</p>
        
        {status === 'success' && (
          <p className="success-message">
            Redirecting you to the dashboard where you can start organizing your files...
          </p>
        )}
        
        {status === 'error' && (
          <button 
            className="retry-button"
            onClick={() => navigate('/auth/mmf-connect')}
          >
            Try Again
          </button>
        )}
      </div>
    </div>
  );
};

export default OAuthCallback;